// Armenian translations
export const hy: Record<string, string> = {
  'menu.dashboard': 'Վահանակ',
  'menu.customers': 'Հաճախորդներ',
  'menu.products': 'Ապրանքներ',
  'menu.users': 'Օգտատերեր',
  'menu.settings': 'Կարգավորումներ',
  'menu.logout': 'Ելք',
  'dashboard.title': 'Վահանակ',
  'dashboard.newOrder': 'Նոր պատվեր',
  'order.title': 'Նոր պատվեր',
  'order.customer': 'Հաճախորդ',
  'order.products': 'Ապրանքներ',
  'order.total': 'Ընդամենը',
  'users.title': 'Օգտատերեր',
  'users.name': 'Անուն',
  'users.email': 'Էլ． փոստ',
  'common.yes': 'Այո',
  'common.no': 'Ոչ',
  'common.cancel': 'Չեղարկել',
  'common.save': 'Պահպանել',
  'common.search': 'Որոնել',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Մուտք',
  'login.welcome': 'Բարի գալուստ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Էլ． փոստ',
  'signup.phone': 'Հեռախոս',
  'menu.reportsAndAccounting': 'Հաշվետվություններ և հաշվապահություն',
  'menu.systemAndCommunication': 'Համակարգ և հաղորդակցություն',
};